@let isDirect = chat()?.conversation_type === ConversationType.direct;
@let isOnline = chat()?.direct_to.status === OnlineStatus.Online;
@let isSmsUnmatched = chat()?.grouping_type === ChatGroupingType.SMSUnmatched;

<div class="chat-header">
  @if (!isThread()) {
    <div
      class="chat-header__info"
      [class.is-group]="!isDirect && !isSmsUnmatched"
      (click)="!isDirect && !isSmsUnmatched && editGroupChat()">
      <app-user-avatar
        radius="12px"
        [size]="48"
        [fontSize]="18"
        [avatar]="chat()?.image"
        [name]="chat()?.name"
        [avatars]="avatars()">
      </app-user-avatar>

      <div class="name-role-status">
        <h6 class="name">{{ chat()?.name }}</h6>
        <p class="role">
          @if (isDirect) {
            {{ chat()?.direct_to.role_value }}
            <span class="status" [class.online]="isOnline">
              @if (isOnline) {
                • {{ 'messageCenter.online' | translate }}
              } @else if (chat()?.direct_to.was_last_online) {
                • {{ 'messageCenter.lastSeen' | translate }} {{ getTimeAgo(chat()?.direct_to.was_last_online) }}
              }
            </span>
          } @else if (chat()?.access_type === GroupType.Private) {
            {{ chat()?.members?.length }} {{ 'messageCenter.participants' | translate }}
          } @else {
            {{ isSmsUnmatched ? '' : 'messageCenter.public' | translate }}
          }
        </p>
      </div>
    </div>

    <div class="chat-header__actions">
      @if (!isDirect && !isSmsUnmatched) {
        <mat-icon class="material-icons-outlined" (click)="editGroupChat()">info</mat-icon>
      }
    </div>
  } @else {
    <div class="chat-header__role">
      <mat-icon class="material-icons-outlined">forum</mat-icon>
      <span class="thread-text">{{ 'messageCenter.thread' | translate }}</span>
    </div>
  }
</div>

@if (showUnreadMessages() && chat()?.unread_messages_ids?.length) {
  <span class="unread-messages">
    {{ chat()?.unread_messages_ids?.length }}
  </span>
}
